import { LoadingLoop } from '..';

export const FullScreenLoader = () => {
  return (
    <main className="absolute h-screen w-screen flex flex-col items-center justify-center bg-gray-900">
      <LoadingLoop />
    </main>
  );
};
